import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const MarketingRouteRedirect: React.FC = () => {
  const { bookId } = useParams<{ bookId?: string }>();
  if (!bookId) {
    return <Navigate to="/manage-books" replace />;
  }
  const encodedBookId = encodeURIComponent(bookId);
  return <Navigate to={`/book-detail/${encodedBookId}?tab=marketing`} replace />;
};

export default MarketingRouteRedirect;
